import { Button, Col, Descriptions, Form, Popconfirm, Space, Tooltip } from "antd";
import React, { ReactNode } from "react";
import { damageCaseIssuerTypesOptions, damageCaseStatusOptions, enmDamageCaseStatus, enmEvaluationMethods, enmEvaluationStatus, enmPolicyholderResponseTypes, evaluationMethodsOptions, evaluationStatusOptions, IDamageCase, IDamageCaseFetchingInfo, IDamageCaseInitialData, IDamageCaseProps, IDamageCaseStates } from "../../baseInfo/damageCase/interfaces";
import { BaseEntityManager } from "../../components/entityManager";
import { enmControlType, enmEntityManagerState, enmPropertyType, IMetadata, IProperty } from "../../components/entityManager/interfaces";
import { Core } from "../../components/infrastructure/core";
import { enmOrderingType, enmValidationLevel, ICallOptions, IFetchingResult, IOrdering, IPaging, IResultSet } from "../../components/infrastructure/models";
import { AllocateEvaluator } from "./allocateEvaluator";
import * as EvaluationComponents from "./components";
import { IEvaluationComponentFormProps, IEvaluationComponentProps } from "./evaluationComponent";
import dayjs from 'dayjs';
import '../index.css'
import { ICenterProps } from "../../baseInfo/center/interfaces";
import AppContext from "../../components/infrastructure/appContext";
import { AndFilter, ComparisonFilter, enmConditionalOperators, IFilter } from "../../components/infrastructure/filtering";
import { AttachmentDownloader } from "../../baseInfo/attachment/attachmentDownloader";
import { ColumnFilter } from "../../components/entityManager/columnfilter";
import { Center } from "../../baseInfo/center";
import { DamageCaseSummary } from "../../financial/damageCaseVoucherPaymentDraft/damageCaseSummary";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { PrinterOutlined } from '@ant-design/icons';
import { enmContactStatus } from "./interfaces";
import { DamageType } from "../../baseInfo/damageType";

export const TriesNames = [
    "اول",
    "دوم",
    "سوم",
    "چهارم",
    "پنجم",
    "ششم",
    "هفتم",
    "هشتم",
    "نهم",
    "دهم",
    "یازدهم",
    "دوازدهم",
    "سیزدهم",
    "چهاردهم",
    "پانزدهم",
    "شانزدهم",
    "هفدهم",
    "هجدهم",
    "نوزدهم",
    "بیستم"
];

export class DamageCaseEvaluator extends BaseEntityManager<IDamageCase, IDamageCaseProps, IDamageCaseStates, IDamageCaseFetchingInfo, IDamageCaseInitialData>{
    static contextType = AppContext;
    static initMetadata = (): IMetadata => {
        return {
            title: "ارزیابی پرونده خسارت",
            name: "DamageCaseEvaluator",
            Properties: [
                {
                    title: "صادر کننده خسارت",
                    dataIndex: "IssuerType",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.combobox,
                    combobox: { options: damageCaseIssuerTypesOptions },
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "شماره پرونده خسارت",
                    dataIndex: "Code",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.numberinput,
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "شماره پیگیری",
                    dataIndex: "TicketNo",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.numberinput,
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "دلیل خسارت",
                    dataIndex: "DamageReason",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "نوع خسارت",
                    dataIndex: "DamageTypeId",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.lookup,
                    lookup: {
                        lookupComponent: DamageType,
                        lookupDisplayFields: ["Name"],
                        showButton: false,
                        dropdownDisplayFields: ["Name"],
                        lookupProperty: "DamageType"
                    },
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "وضعیت پرونده",
                    dataIndex: "Status",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.combobox,
                    combobox: {
                        optionsFunc: (_: any, record: IDamageCase) => damageCaseStatusOptions.map(o => {
                            if (!record)
                                return { title: o.title, value: o.value };
                            if (record.Status === enmDamageCaseStatus.ReceiveDepreciated && record.DamageTypeId !== 2)
                                return { title: 'در انتظار تایید انتقال مالکیت', value: o.value };
                            return { title: o.title, value: o.value };
                        })
                    },
                    disabled: true,
                    filterable: true,
                    width: 150
                },
                {
                    title: "وضعیت ارزیابی",
                    dataIndex: "EvaluationStatus",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.combobox,
                    combobox: {
                        optionsFunc: (_: any, record: IDamageCase) => evaluationStatusOptions.map(o => {
                            if (!record)
                                return { title: o.title, value: o.value, name: o.name };
                            if (record.EvaluationStatus === enmEvaluationStatus.DamageEstimation) {
                                let damageEstiomationTitle: string | null = null;
                                const damageEstimations = record.DamageCaseEvaluators[record.DamageCaseEvaluators.length - 1]?.Estimations;
                                if (damageEstimations && damageEstimations.length > 0) {
                                    const currentDamageEstiomation = damageEstimations[damageEstimations.length - 1];
                                    if (currentDamageEstiomation !== null && !currentDamageEstiomation.ExpertConfirmation)
                                        damageEstiomationTitle = "منتظر اعلام نظر نهایی توسط کارشناس شرکت زبده";
                                }
                                return { title: damageEstiomationTitle ?? o.title, value: o.value, name: o.name };
                            }
                            else if (record.EvaluationStatus === enmEvaluationStatus.PolicyholderRejected) {
                                const title = o.title + (record && record.NumberOfPreviousEvaluations < 20 ? ` (بار ${TriesNames[record.NumberOfPreviousEvaluations]}) ` : ' (بیش از بیست بار) ');
                                return { title, value: o.value, name: o.name };
                            }
                            else if (record.EvaluationStatus === enmEvaluationStatus.ContactSetting) {
                                const methodOpt = evaluationMethodsOptions.find(m => m.value === record.EvaluationMethod);
                                const title = methodOpt?.contactSettingStatusTitle;
                                const name = methodOpt?.contactSettingCommandTitle;
                                return { title, value: o.value, name };
                            }
                            else if (record.EvaluationStatus === enmEvaluationStatus.MakingContact) {
                                const methodOpt = evaluationMethodsOptions.find(m => m.value === record.EvaluationMethod);
                                const title = methodOpt?.makingContactStatusTitle;
                                const name = methodOpt?.makingContactCommandTitle;
                                return { title, value: o.value, name };
                            }
                            else if (record.EvaluationStatus === enmEvaluationStatus.SendEssentials && record.DamageTypeId === 3) { // سرقت
                                return { title: 'در انتظار دریافت مدارک سرقت', value: o.value, name: 'دریافت مدارک سرقت' };
                            }
                            else {
                                return { title: o.title, value: o.value, name: o.name };
                            }
                        })
                    },
                    disabled: true,
                    filterable: true,
                    width: 200
                },
                {
                    title: "مرکز ارزیابی",
                    dataIndex: "EvaluatorId",
                    controlType: enmControlType.template,
                    filterable: false,
                    sortable: false,
                    renderColumn: (_: any, record: IDamageCase) => {
                        let evaluator = record.DamageCaseEvaluators[record.DamageCaseEvaluators.length - 1]?.Evaluator;
                        return (
                            <>
                                {evaluator?.FullName}
                            </>
                        );
                    },
                    renderControl: (currentEntity: IDamageCase) => {
                        let evaluator = currentEntity.DamageCaseEvaluators[currentEntity.DamageCaseEvaluators.length - 1]?.Evaluator;
                        return (
                            <>
                                {evaluator?.FullName}
                            </>
                        );
                    },
                    width: 200
                },
                {
                    title: "سریال بیمه نامه",
                    dataIndex: "PolicyEquipmentModel.Policy.SerialNo",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150
                },
                {
                    title: "کد ملی بیمه گزار/مشتری",
                    dataIndex: "PolicyEquipmentModel.Policy.Policyholder.NationalCode",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150
                },
                {
                    title: "بیمه گزار/مشتری",
                    dataIndex: "PolicyEquipmentModel.Policy.Policyholder.FullName",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: false,
                    sortable: false,
                    width: 200,
                    renderColumn: (_: any, record: IDamageCase) => {
                        const { FullName } = record.PolicyEquipmentModel.Policy.Policyholder;
                        const policyholderFullName = `${FullName} - ${record.EmergencyCallNumber}`;
                        return (
                            <>
                                {policyholderFullName}
                            </>
                        );
                    }
                },
                {
                    title: "نوع تجهیز",
                    dataIndex: "PolicyEquipmentModel.Equipment.Name",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 120
                },
                {
                    title: "برند",
                    dataIndex: "PolicyEquipmentModel.BrandTitle",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    sortable: true,
                    width: 120
                },
                {
                    title: "مدل",
                    dataIndex: "PolicyEquipmentModel.EquipmentModelTitle",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    sortable: true,
                    width: 120
                },
                {
                    title: "IMEI/سریال دستگاه",
                    dataIndex: "PolicyEquipmentModel.EquipmentSerialNo",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150
                },
                {
                    title: "تایید انتقال مالکیت",
                    dataIndex: "ConfirmPossessionTransition",
                    propertyType: enmPropertyType.boolean,
                    controlType: enmControlType.checkbox,
                    filterable: true,
                    width: 120,
                    showColumn: false
                },
                {
                    title: "روش ارزیابی",
                    dataIndex: "EvaluationMethod",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.combobox,
                    combobox: { options: evaluationMethodsOptions.map(a => { return { name: a.name, title: a.name, value: a.value } }) },
                    disabled: true,
                    filterable: true,
                    width: 150,
                    visibility: (currentEntity: IDamageCase) => {
                        return !currentEntity.DamageReason?.includes('سرقت');
                    }
                },
                {
                    title: "تاریخ خسارت",
                    dataIndex: "DamageDate",
                    propertyType: enmPropertyType.date,
                    controlType: enmControlType.date,
                    disabled: true,
                    filterable: true,
                    showColumn: false,
                    width: 150
                },
                {
                    title: "شماره تماس بیمه گزار/مشتری",
                    dataIndex: "EmergencyCallNumber",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    disabled: true,
                    filterable: true,
                    showColumn: false,
                    width: 150
                }
            ]
        };
    }
    private evaluatorFilterProp: IProperty = {
        dataIndex: "Evaluator",
        controlType: enmControlType.lookup,
        propertyType: enmPropertyType.number,
        allowNull: true,
        title: "مرکز ارزیابی",
        lookup: {
            lookupComponent: Center,
            lookupDisplayFields: ["FullName"],
            dropdownDisplayFields: ["FullName", "NationalCode"],
            lookupProperty: ""
        }
    }
    private evaluatorFilterValue?: number;
    private evaluatorFilterOperator?: enmConditionalOperators;
    onInitializing() {
        this.extraFormNodeMarginTop = 5;
        this.viewButtonTitle = () => "مشاهده پرونده خسارت";

        this.searchable = true;
        this.searchArea = {
            columnsPerRow: 2,
            defaultValues: () => {
                return {
                    Status: { operator: enmConditionalOperators.GreaterOrEqual, value: enmDamageCaseStatus.AssignEvaluator }
                };
            },
            onReset: () => {
                this.evaluatorFilterValue = undefined;
                this.evaluatorFilterOperator = 0;
            }
        };

        this.originalOrderings = () => [
            { OrderBy: enmOrderingType.Ascending, Property: "Status" },
            { OrderBy: enmOrderingType.Ascending, Property: "EvaluationStatus" },
            { OrderBy: enmOrderingType.Descending, Property: "Id" }
        ];

        this.onLoaded = (initialData: IDamageCaseInitialData) => {

            if (initialData?.Center?.Id === 1 && this.searchArea) {
                const { dataIndex, title } = this.evaluatorFilterProp;
                this.searchArea.render = () => {
                    return [
                        <Form.Item name={dataIndex} key={dataIndex} label={title}>
                            <ColumnFilter
                                parent={this}
                                property={this.evaluatorFilterProp}
                                onChange={currentFilter => {
                                    this.evaluatorFilterValue = !!currentFilter?.value ? currentFilter.value["Id"] : undefined;
                                    this.evaluatorFilterOperator = currentFilter?.operator;
                                }}
                                preparelookupProps={(lookupProps: ICenterProps) => {
                                    lookupProps.isEvaluator = true;
                                    return lookupProps;
                                }}
                            />
                        </Form.Item>
                    ];
                };
            }
        }

        this.onDataFetching = (fetchingInfo, onViewMode) => {
            if (this.initialData?.Center?.Id === 1 && !!this.evaluatorFilterValue && this.evaluatorFilterOperator !== undefined) {
                fetchingInfo.EvaluatorFilter = new ComparisonFilter("Evaluator.Id", this.evaluatorFilterOperator, this.evaluatorFilterValue);
            }
            else
                fetchingInfo.EvaluatorFilter = undefined;
            fetchingInfo.EvaluatorId = this.initialData?.Center?.Id;
            fetchingInfo.LoadNavigations = onViewMode;

        };

        this.onDataFetched = result => {
            result && result.Data && result.Data.forEach(i => i.EmergencyCallNumber = '0' + i.EmergencyCallNumber);
            return result;
        };

        this.extraHeaderButtons = () => {
            let buttons: React.ReactNode[] = [];
            let commands: React.ReactNode[] = [];

            // اگر کاربر زبده باشد 
            if (this.state.state === enmEntityManagerState.View && this.initialData?.Center?.Id === 1 && this.initialData?.AccessList["AllocateEvaluator"]) {
                if (this.selectedEntity?.Status === enmDamageCaseStatus.Financial) {

                    if (!this.selectedEntity?.SentToBranch)
                        commands.push(
                            <Tooltip key="sendDamageCaseToBranch" title="ارسال پرونده خسارت به شعبه مربوطه از طریق اتوماسیون اداری سامان">
                                <Button key="sendDamageCaseToBranch"
                                    style={{ lineHeight: '0.5em', verticalAlign: 'middle', width: '140px' }}
                                    type="primary"
                                    onClick={this.sendDamageCaseToBranch}
                                >
                                    ارسال به شعبه
                                </Button>
                            </Tooltip >
                        );
                }
            }

            // پرونده در هر وضعیتی باشد
            if (this.state.state === enmEntityManagerState.View) {
                commands.push(
                    <ReactToPrint key="printDamageCase" content={() => this.viewRef ?? null}>
                        <PrintContextConsumer>
                            {({ handlePrint }) => (
                                <Button key="printDamageCase"
                                    icon={<PrinterOutlined />}
                                    style={{ lineHeight: '0.5em', verticalAlign: 'middle', width: '140px' }}
                                    type="default"
                                    onClick={handlePrint}>
                                    چاپ پرونده
                                </Button>
                            )}
                        </PrintContextConsumer>
                    </ReactToPrint>
                );

                if (this.selectedEntity?.Status === enmDamageCaseStatus.Financial && this.initialData?.AccessList["PrintDamageCaseSummary"]) {
                    commands.push(
                        <Button key="printDamageCaseSummary"
                            style={{ lineHeight: '0.5em', verticalAlign: 'middle', width: '140px' }}
                            type="primary"
                            onClick={this.showDamageCaseSummary}
                        >
                            چاپ خلاصه پرونده
                        </Button>
                    );
                }

                if (this.selectedEntity?.Status === enmDamageCaseStatus.Financial && this.initialData?.AccessList["DownloadDamageCaseZipFile"]) {
                    commands.push(
                        <Button key="downloadDamageCaseZipFile"
                            style={{ lineHeight: '0.5em', verticalAlign: 'middle', width: '140px' }}
                            type="primary"
                            onClick={this.downloadDamageCaseZipFile}
                        >
                            دانلود مدارک خسارت
                        </Button>
                    );
                }
            }

            if (commands.length)
                buttons.push(
                    <Space key="extraButtons">
                        {commands}
                    </Space>
                );

            return buttons;
        };

        this.renderingToolbar = () => {
            let result: ReactNode[] = [];
            let entity = this.selectedEntity!;
            if (!entity)
                return <></>;
            //var evaluatorCode = this.initialData?.Center?.Code;
            //var evaluatorCodeLike = evaluatorCode ? evaluatorCode.toString().padStart(Math.ceil(evaluatorCode / 5.0) * 5, '0') : "";
            const damageCaseEvaluator = entity.DamageCaseEvaluators[entity.DamageCaseEvaluators.length - 1];
            const evaluatorId = damageCaseEvaluator?.EvaluatorId;
            const allocateEvaluatorAccess = this.initialData?.AccessList["AllocateEvaluator"];
            const pickupAccess = this.initialData?.AccessList["Pickup"];

            const command = entity.EvaluationStatus !== undefined && enmEvaluationStatus[Number(entity.EvaluationStatus)];
            const commandAccess = !!command && this.initialData?.AccessList[command];

            if (allocateEvaluatorAccess &&
                (entity.Status === enmDamageCaseStatus.AssignEvaluator || (entity.Status === enmDamageCaseStatus.Evaluation && [enmEvaluationStatus.PolicyholderConfirmation].indexOf(entity.EvaluationStatus ?? 0) === -1)) &&
                entity.DamageCaseEvaluators.filter(f => f.Substatus === enmEvaluationStatus.PolicyholderConfirmation || f.Substatus === enmEvaluationStatus.PolicyholderRejected).length < 2) {
                // دسترسی تخصیص داشته باشد یا ادمین باشد
                // و خسارت در مرحله تخصیص ارزیاب یا ارزیابی باشد
                // و درصورتی که اگر بیمه گزار/مشتری ارزیابی را برای بار اول رد کرده باشد ، هنوز برای باردوم رد نکرده باشد
                // Allocate  

                result.push(
                    <Col key="Allocate" style={{ marginLeft: 10 }}>
                        <Button type="default" onClick={this.onAllocateEvaluatorClick} >تخصیص مرکز ارزیابی</Button>
                    </Col>
                );
            }
            if (pickupAccess && (this.initialData?.Center?.Id !== evaluatorId || entity.EvaluationStatus === enmEvaluationStatus.PolicyholderRejected) && (entity.Status === enmDamageCaseStatus.AssignEvaluator || (entity.Status === enmDamageCaseStatus.Evaluation && [enmEvaluationStatus.DamageEstimation, enmEvaluationStatus.PolicyholderConfirmation].indexOf(entity.EvaluationStatus ?? 0) === -1)) && !!this.initialData?.Center?.IsEvaluator && (entity.NumberOfPreviousEvaluations < 1 || this.initialData.Center.SecondEvaluationPermission)) {
                // کاربر زبده باشد
                // پرونده در دست ارزیاب دیگری باشد
                //خسارت در مرحله تخصیص ارزیاب یا ارزیابی باشد
                // و این کاربر مرکز ارزیابی باشد
                // درصورتی که بار اول ارزیابی باشد یا مجوز ارزیابی برای بار دوم را داشته باشد
                // Pickup 
                result.push(
                    <Col key="Pickup" style={{ marginLeft: 10 }}>
                        <Popconfirm okButtonProps={{ size: "middle" }} cancelButtonProps={{ size: "middle" }} okText="بلی" cancelText="خیر" title="آیا مایلید ارزیابی پرونده را انجام دهید؟"
                            onConfirm={this.onPickupClick}>
                            <Button type="default">گرفتن پرونده</Button>
                        </Popconfirm>
                    </Col>
                );
            }
            else if (entity.Status === enmDamageCaseStatus.Evaluation
                && commandAccess
                && !!this.initialData?.Center
                && (
                    (this.initialData.Center.Id !== 1 && this.initialData.Center.Id === evaluatorId)
                    ||
                    (this.initialData.Center.Id === 1 && ((entity.EvaluationStatus === enmEvaluationStatus.DamageEstimation && damageCaseEvaluator.Estimations.length) || evaluatorId === 1))
                )
                && this.initialData.Center.IsEvaluator
                && entity.EvaluationStatus !== enmEvaluationStatus.Rejected
                && entity.EvaluationStatus !== enmEvaluationStatus.DefectiveDocuments
                && entity.EvaluationStatus !== enmEvaluationStatus.PolicyholderConfirmation
                && entity.EvaluationStatus !== enmEvaluationStatus.PolicyholderRejected
                && entity.EvaluationStatus !== enmEvaluationStatus.EvaluationComplete) {

                let commandTitle = evaluationStatusOptions.find(o => o.value === entity.EvaluationStatus)?.name;

                if (entity.EvaluationStatus === enmEvaluationStatus.ContactSetting) {
                    commandTitle = evaluationMethodsOptions.find(m => m.value === entity.EvaluationMethod)?.contactSettingCommandTitle;
                }
                if (entity.EvaluationStatus === enmEvaluationStatus.MakingContact) {
                    commandTitle = evaluationMethodsOptions.find(m => m.value === entity.EvaluationMethod)?.makingContactCommandTitle;
                }
                if (entity.EvaluationStatus === enmEvaluationStatus.DamageEstimation) {
                    const damageEstimations = entity.DamageCaseEvaluators[entity.DamageCaseEvaluators.length - 1]?.Estimations;
                    if (damageEstimations && damageEstimations.length > 0) {
                        const currentDamageEstiomation = damageEstimations[damageEstimations.length - 1];
                        if (currentDamageEstiomation !== null && !currentDamageEstiomation.ExpertConfirmation) {
                            if (this.initialData.Center.Id === 1)
                                commandTitle = "اعلام نظر نهایی";
                            else
                                commandTitle = "";
                        }
                    }
                }
                if (!!commandTitle)
                    result.push(
                        <Col key="command" style={{ marginLeft: 10 }}>
                            <Button type="default" onClick={() => this.fetchItem(entity.RowGuid)}>
                                {commandTitle}
                            </Button>
                        </Col>
                    );
            }

            // کاربر زبده باشد و  پرونده دروضعیت ارزیابی و دریافت دستگاه یا مدراک باشد
            if (this.initialData?.Center?.Id === 1 && this.selectedEntity?.Status === enmDamageCaseStatus.Evaluation && this.selectedEntity?.EvaluationStatus === enmEvaluationStatus.SendEssentials) {
                if (this.initialData.AccessList["ReceiveEssentials"]) {
                    let title = this.selectedEntity.DamageTypeId === 1 ? "دریافت دستگاه و لوازم جانبی" : "دریافت مدارک سرقت";
                    result.push(
                        <Col key="receiveEssentials" style={{ marginLeft: 10 }}>
                            <Popconfirm okButtonProps={{ size: "middle" }} cancelButtonProps={{ size: "middle" }} okText="بلی" cancelText="خیر" title={`آیا ${title} مورد تایید است؟`}
                                onConfirm={this.receiveEssentials}>
                                <Button key="receiveEssentials" type="primary">{title}</Button>
                            </Popconfirm>
                        </Col>
                    );
                }
            }

            // پرونده در وضعیت مالی باشد
            if (this.initialData && this.selectedEntity?.Status === enmDamageCaseStatus.Financial) {
                // دارای دسترسی چاپ خلاصه پرونده باشد
                if (this.initialData.AccessList["PrintDamageCaseSummary"])
                    result.push(
                        <Col key="printDamageCaseSummary" style={{ marginLeft: 10 }}>
                            <Button key="printDamageCaseSummary" type="primary" onClick={this.showDamageCaseSummary}>چاپ خلاصه پرونده</Button>
                        </Col>
                    );

                // دارای دسترسی ارسال به شعبه باشد
                if (this.initialData.AccessList["SendDamageCaseToBranch"] && !entity.SentToBranch)
                    result.push(
                        <Col key="sendDamageCaseToBranch" style={{ marginLeft: 10 }}>
                            <Tooltip title="ارسال پرونده خسارت به شعبه مربوطه از طریق اتوماسیون اداری سامان">
                                <Button key="sendDamageCaseToBranch" type="primary" onClick={this.sendDamageCaseToBranch}>ارسال به شعبه</Button>
                            </Tooltip>
                        </Col>
                    );

                // اگر کاربر دسترسی دانلود مدارک داشته باشد
                if (this.initialData.AccessList["DownloadDamageCaseZipFile"]) {
                    result.push(
                        <Col key="downloadDamageCaseZipFile" style={{ marginLeft: 10 }}>
                            <Button key="downloadDamageCaseZipFile" type="primary" onClick={this.downloadDamageCaseZipFile}>دانلود مدارک خسارت</Button>
                        </Col>
                    );
                }
            }

            // اگر کاربر دسترسی حذف داشته باشد و پرونده نهایتا در وضعیت ارزیابی باشد
            if (this.initialData?.AccessList["RemoveDamageCase"] && [enmDamageCaseStatus.Create, enmDamageCaseStatus.AssignEvaluator, enmDamageCaseStatus.Evaluation].indexOf(this.selectedEntity?.Status ?? enmDamageCaseStatus.Create) > -1) {
                result.push(
                    <Col key="RemoveDamageCase" style={{ marginLeft: 10 }}>
                        <Popconfirm okButtonProps={{ size: "middle" }} cancelButtonProps={{ size: "middle" }} okText="بلی" cancelText="خیر" title="آیا مایلید پرونده خسارت را حذف نمایید؟"
                            onConfirm={() => this.removeDamageCase(entity.TicketNo)}>
                            <Button type="default">حذف پرونده خسارت</Button>
                        </Popconfirm>
                    </Col>
                );
            }

            return result.length ? (<> {result} </>) : (<></>);
        };

        this.extraViewNode = () => {
            const { currentEntity, evaluationSteps } = this.state;
            if (!currentEntity)
                return;

            let steps: React.ReactNode[] = [];

            let damageCaseEvaluatorId: number | undefined = undefined;

            currentEntity.DamageCaseEvaluators.forEach(damageCaseEvaluator => {
                if (damageCaseEvaluator.Id !== damageCaseEvaluatorId) {
                    damageCaseEvaluatorId = damageCaseEvaluator.Id;
                    let evaluator = damageCaseEvaluator.Evaluator;
                    steps.push(
                        <div key={(damageCaseEvaluator as any).RowGuid} style={{ padding: "5px 0", pageBreakInside: "avoid" }}>
                            <div className="box box-blue">
                                <div className="box-title">
                                    <div className="caption">
                                        <Descriptions>
                                            <Descriptions.Item><b>تخصیص ارزیاب</b></Descriptions.Item>
                                            <Descriptions.Item label="تاریخ"><span style={{ direction: "ltr", float: "left" }}>{dayjs(damageCaseEvaluator.CreateDateTime).calendar('jalali').locale('fa').format("YYYY/MM/DD HH:mm")}</span></Descriptions.Item>
                                            <Descriptions.Item label="کاربر">{damageCaseEvaluator.Creator?.FullName ?? 'کارشناس پرونده خسارت'}</Descriptions.Item>
                                        </Descriptions>
                                    </div>
                                </div>
                                <div className="box-body form">
                                    <div className="form-body">
                                        <div style={{ padding: 20 }}>
                                            <label>مرکز ارزیابی</label>
                                            <p>{evaluator.NationalCode + " " + evaluator.FullName}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                }

                evaluationSteps.filter(s => s.DamageCaseEvaluatorId === damageCaseEvaluatorId)
                    .forEach((s, i) => {
                        const evaluationMethod = this.state.currentEntity?.EvaluationMethod;
                        let title = evaluationStatusOptions.find(o => o.value === s.Substatus)?.name;

                        const evaluationMethodChanged = !!evaluationSteps.find((v, vIndex) => v.ContactStatus === enmContactStatus.EvaluationMethodToPolicyholderInPerson && i <= vIndex);
                        if (s.Substatus === enmEvaluationStatus.ContactSetting) {
                            title = evaluationMethodsOptions.find(m => (evaluationMethodChanged && m.value === enmEvaluationMethods.VideoCall) || m.value === evaluationMethod)?.contactSettingCommandTitle;
                        }
                        if (s.Substatus === enmEvaluationStatus.MakingContact) {
                            title = evaluationMethodsOptions.find(m => (evaluationMethodChanged && m.value === enmEvaluationMethods.VideoCall) || m.value === evaluationMethod)?.makingContactCommandTitle;
                        }

                        let repeatedStep = !!evaluationSteps.find((v, vIndex) => v.Substatus === s.Substatus && i > vIndex);
                        if (repeatedStep)
                            title += ' (مجدد) ';
                        let dateTime = dayjs(s.CreateDateTime).calendar('jalali').locale('fa').format("YYYY/MM/DD HH:mm");
                        let history: React.ReactNode;
                        let formName = enmEvaluationStatus[Number(s.Substatus)] + "Form";
                        let formProps: IEvaluationComponentFormProps<any> = {
                            currentEntity: s,
                            loading: false,
                            disabled: true,
                            damageCase: this.state.currentEntity!,
                            damageCaseDocumentTypeAttachments: []
                        };

                        if (s.Substatus === enmEvaluationStatus.DocumentCheck) {
                            const prevCheckCount = evaluationSteps.filter((v, vIndex) => v.Substatus === s.Substatus && i > vIndex).length;
                            const attachments = this.state.attachments.filter((_, k) => k <= prevCheckCount).flatMap(a => a);
                            (formProps as any)["damageCaseDocumentTypeAttachments"] = attachments;
                            (formProps as any)["numberOfPreviousEvaluations"] = evaluationSteps.filter((v, vIndex) => v.Substatus === enmEvaluationStatus.PolicyholderConfirmation && v.ResponseType === enmPolicyholderResponseTypes.Objection && i > vIndex).length
                        }

                        const Component = (EvaluationComponents as any)[formName];
                        if (Component) {
                            const policyEquipmentModel = this.state.currentEntity?.PolicyEquipmentModel;

                            if (formName === "DamageEstimationForm") {
                                (formProps as any).insuredValue = policyEquipmentModel?.InsuredValue;
                            }
                            if (formName === "PolicyholderConfirmationForm") {
                                (formProps as any).parent = this;
                            }
                            if (formName === "ContactSettingForm") {
                                (formProps as any).evaluationMethodChanged = evaluationMethodChanged;
                            }
                            history = (
                                <div style={{ padding: 20 }}>
                                    <Component key={s.RowGuid} {...formProps} />
                                </div>
                            );

                            steps.push(
                                <div key={s.RowGuid} style={{ padding: "5px 0", pageBreakInside: "avoid" }}>
                                    <div className="box box-blue">
                                        <div className="box-title">
                                            <div className="caption">
                                                <Descriptions>
                                                    <Descriptions.Item><b>{title}</b></Descriptions.Item>
                                                    <Descriptions.Item label="تاریخ"><span style={{ direction: "ltr", float: "left" }}>{dateTime}</span></Descriptions.Item>
                                                    <Descriptions.Item label="کاربر">{s.Creator?.FullName ?? 'کارشناس پرونده خسارت'}</Descriptions.Item>
                                                </Descriptions>
                                            </div>
                                        </div>
                                        <div className="box-body form">
                                            <div className="form-body">
                                                {history}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        }
                        else if (s.Substatus === enmEvaluationStatus.DefectiveDocuments) {
                            history = (
                                <div style={{ padding: 20 }}>
                                    <AttachmentDownloader key={s.RowGuid} attachments={s.DamageCaseDocumentTypes.flatMap((a: any) => a.DamageCaseDocumentTypeAttachments)} />
                                </div>
                            );
                            steps.push(
                                <div key={s.RowGuid} style={{ padding: "5px 0", pageBreakInside: "avoid" }}>
                                    <div className="box box-blue">
                                        <div className="box-title">
                                            <div className="caption">
                                                <Descriptions>
                                                    <Descriptions.Item><b>{title}</b></Descriptions.Item>
                                                    <Descriptions.Item label="تاریخ"><span style={{ direction: "ltr", float: "left" }}>{dateTime}</span></Descriptions.Item>
                                                    <Descriptions.Item label="کاربر">{s.Creator?.FullName}</Descriptions.Item>
                                                </Descriptions>
                                            </div>
                                        </div>
                                        <div className="box-body form">
                                            <div className="form-body">
                                                {history}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        }
                    });
            });

            return (
                <>
                    {steps}
                </>
            );
        };

        this.originalFilter = () => {
            const { params } = this.context;
            const evaluationStatusParam = params['evaluationstatus'];
            const statusParam = params['status'];
            let filter: IFilter | undefined;
            if (!!evaluationStatusParam) {
                const evaluationStatusValues = Core.enumToArray(enmEvaluationStatus);
                const evaluationStatusId = evaluationStatusValues.find(v => v.name.toLowerCase() === evaluationStatusParam)?.id;
                this.metadata.title = 'پرونده های ' + evaluationStatusOptions.find(e => e.value === evaluationStatusId)!.title;
                filter = ComparisonFilter.Equal<IDamageCase>(d => d.EvaluationStatus, evaluationStatusId);
            }
            else if (!!statusParam) {
                const statusValues = Core.enumToArray(enmDamageCaseStatus);
                const statusId = statusValues.find(v => v.name.toLowerCase() === statusParam)?.id;
                this.metadata.title = 'پرونده های جدید یا ارزیابی مجدد';
                filter = ComparisonFilter.Equal<IDamageCase>(d => d.Status, statusId);
            }
            else
                this.metadata.title = "ارزیابی پرونده خسارت";
            if (params.id) {
                if (filter)
                    return new AndFilter([new ComparisonFilter("RowGuid", enmConditionalOperators.Equal, params.id), filter]);
                return new ComparisonFilter("RowGuid", enmConditionalOperators.Equal, params.id);
            }
            return filter;
        };

        this.onFirstDataLoad = () => {
            const { params } = this.context;
            if (params.id && this.state.data) {
                this.fetchItem(this.state.data[0].RowGuid);
            }
        };

        this.setRecordClassName = record => {
            const lastEvaluation = record.DamageCaseEvaluators[record.DamageCaseEvaluators.length - 1];
            const damageEstimations = lastEvaluation?.Estimations;
            const estimation = damageEstimations && damageEstimations.length > 0 && damageEstimations[damageEstimations.length - 1];
            const waitingForExpert = estimation && estimation.ExpertConfirmation === null;

            const isNewRecordOrDocumentChecking = record.Status === enmDamageCaseStatus.Evaluation &&
                lastEvaluation?.EvaluatorId === this.initialData?.Center?.Id &&
                (lastEvaluation?.EvaluationStartTime === null
                    || (record.EvaluationStatus !== undefined && ([enmEvaluationStatus.DocumentCheck, enmEvaluationStatus.ContactSetting, enmEvaluationStatus.MakingContact, enmEvaluationStatus.SendEssentials].indexOf(record.EvaluationStatus) > -1))
                    || ((this.initialData?.Center?.Id === 1 || !waitingForExpert) && record.EvaluationStatus === enmEvaluationStatus.DamageEstimation));

            const waitingForZobdehExpert = this.initialData?.Center?.Id === 1 && (waitingForExpert || record.Status === enmDamageCaseStatus.AssignEvaluator);
            return waitingForZobdehExpert || isNewRecordOrDocumentChecking ? 'new-record' : null;
        };
    }
    onEntityView = (entity: IDamageCase) => {
        let fetchOpt: ICallOptions = {
            url: "damagecaseevaluator/getallevaluationsteps",
            data: { damageCaseId: entity.Id },
            onSuccess: (result: IResultSet<any>) => {
                if (!result.ValidationState.Successful)
                    return;
                result.Data.steps = (result.Data.steps as { CreateDateTime: any; }[]).sort((a, b) => a.CreateDateTime > b.CreateDateTime ? 1 : -1) ?? [];
                this.setState({ state: enmEntityManagerState.View, currentEntity: entity, evaluationSteps: result.Data.steps ?? [], attachments: result.Data.attachments ?? [] });
            },
            onError: () => {

            }
        };
        this.callApi(fetchOpt);
        return false;
    }
    async fetchItem(rowGuid: string, assignEvaluator: boolean = false) {
        let fetchingInfo = {
            Orderings: [] as IOrdering[],
            Paging: { PageNo: 1, PageSize: 1 } as IPaging,
            Filter: ComparisonFilter.Equal<IDamageCase>(e => e.RowGuid, rowGuid) as IFilter,
            LoadNavigations: true
        } as IDamageCaseFetchingInfo;

        this.onDataFetching?.call(this, fetchingInfo, true);

        let fetchOpt: ICallOptions = {
            url: this.getUrl,
            data: { fetchingInfo },
            onSuccess: (result: IResultSet<any>) => {
                if (!result.ValidationState.Successful)
                    return;
                let res = result as IFetchingResult<IDamageCase>;
                if (this.onDataFetched)
                    res = this.onDataFetched(res);
                if (!!res.Data)
                    this.handleCommand(res.Data[0], assignEvaluator);
            },
            onError: () => {

            }
        };
        await this.callApi(fetchOpt);
    }
    handleCommand = (entity: IDamageCase, assignEvaluator: boolean) => {
        let command = enmEvaluationStatus[Number(entity.EvaluationStatus)];

        this.destroyLookupForms(this.state.displayLookupForm);

        if (assignEvaluator) {
            this.addLookupForm("AllocateEvaluator",
                <AllocateEvaluator
                    key="AllocateEvaluator"
                    invokePath={this.metadata.title}
                    isChildComponent={true}
                    onClose={this.onLookupClosed}
                    damageCase={entity}
                />);
        }
        else {
            const props: IEvaluationComponentProps = {
                damageCase: entity,
                invokePath: this.metadata.title,
                assignEvaluatorAccess: !!this.initialData?.AccessList['AllocateEvaluator'],
                isChildComponent: true,
                onClose: () => {
                    this.onLookupClosed();
                },
                nextStatus: (damageCase: IDamageCase, forceAssignEvaluator: boolean = false) => {
                    if ([enmEvaluationStatus.Rejected, enmEvaluationStatus.SendEssentials, enmEvaluationStatus.PolicyholderConfirmation].indexOf(damageCase.EvaluationStatus!) < 0)
                        this.fetchItem(damageCase.RowGuid, forceAssignEvaluator);
                    else
                        this.onLookupClosed();
                }
            };

            const Component = (EvaluationComponents as any)[command];
            this.addLookupForm(command, <Component key={command} {...props} />);
        }
    }
    onAllocateEvaluatorClick = () => {
        if (!this.selectedEntity)
            return;
        this.addLookupForm("AllocateEvaluator",
            <AllocateEvaluator
                key="AllocateEvaluator"
                invokePath={this.metadata.title}
                isChildComponent={true}
                onClose={this.onLookupClosed}
                damageCase={this.selectedEntity!}
            />);
    }
    onPickupClick = async () => {
        if (!this.selectedEntity)
            return;

        let fetchOpt: ICallOptions = {
            url: "damagecaseevaluator/pickup",
            data: {
                damageCase: { Id: this.selectedEntity.Id, RowGuid: this.selectedEntity.RowGuid, RowVrsn: this.selectedEntity.RowVrsn }
            },
            onSuccess: (result: IResultSet<any>) => {
                if (result.ValidationState.Successful) {
                    Core.successNotification('ارزیاب با موفقیت اختصاص داده شد');
                    this.fetchItem(result.Data.RowGuid);
                }
            }
        };
        return await this.callApi(fetchOpt);
    }
    onLookupClosed = () => {
        this.originalFilter = undefined;
        this.metadata.title = "ارزیابی پرونده خسارت";
        this.closeLookupForm();
        this.fetchData();
    }
    showDamageCaseSummary = () => {
        if (!this.selectedEntity)
            return;
        this.addLookupForm('DamageCaseSummary',
            <DamageCaseSummary
                damageCaseId={this.selectedEntity.Id}
                onClose={() => this.closeLookupForm()}
                invokePath={this.metadata.title}
                invoker={'damagecaseevaluator'}
            />
        );
    }
    sendDamageCaseToBranch = async () => {
        let damageCase = this.selectedEntity;
        if (!damageCase || !!damageCase.SentToBranch) return;
        let fetchOpt: ICallOptions = {
            url: "damagecaseevaluator/senddamagecasetobranch",
            data: { damageCaseId: damageCase.Id, rowVrsn: damageCase.RowVrsn },
            onSuccess: res => {
                if (res.ValidationState.Successful && !res.ValidationState.ValidationResults.filter(v => v.Level === enmValidationLevel.Warning).length) {
                    Core.successNotification("پرونده خسارت با موفقیت از طریق اتوماسیون اداری برای شعبه ارسال شد.");
                    this.fetchData();
                }
            }
        };
        await this.callApi(fetchOpt);
    }
    removeDamageCase = async (ticketNo: number) => {
        let fetchOpt: ICallOptions = {
            url: "damagecaseevaluator/RemoveDamageCase",
            data: { ticketNo },
            onSuccess: async result => {
                if (result.ValidationState.Successful) {
                    Core.successNotification('پرونده خسارت حذف شد');
                    await this.fetchData();
                }
            },
            onError: () => {

            }
        };
        await this.callApi(fetchOpt);
    }
    receiveEssentials = async () => {
        let damageCase = this.selectedEntity;
        if (!damageCase) return;

        let title = this.selectedEntity!.DamageTypeId === 1 ? "دستگاه و لوازم جانبی" : "مدارک سرقت";
        let fetchOpt: ICallOptions = {
            url: "damagecaseevaluator/receiveessentials",
            data: { damageCaseId: damageCase.Id, rowVrsn: damageCase.RowVrsn },
            onSuccess: res => {
                if (res.ValidationState.Successful) {
                    Core.successNotification(`${title} با موفقیت دریافت شد`);
                    this.fetchData();
                }
            }
        };
        await this.callApi(fetchOpt);
    }
    downloadDamageCaseZipFile = async () => {
        let damageCase = this.selectedEntity;
        if (!damageCase) return;
        let fetchOpt: ICallOptions = {
            url: "damagecaseevaluator/downloaddamagecasezipfile",
            data: { damageCaseId: damageCase.Id },
            onSuccess: res => {
                if (res.ValidationState.Successful) {
                    const base64Data = (res as IResultSet<string>).Data!;
                    const link = document.createElement("a");
                    link.href = `data:application/zip;base64,${base64Data}`;
                    link.download = `مدارک پرونده خسارت شماره_${damageCase?.Code}.zip`;
                    link.click();
                    link.remove();
                }
            }
        };
        await this.callApi(fetchOpt);
    }
}